module.exports = __webpack_public_path__ + "img/g_mro_4.391648b0.png";